import { render, staticRenderFns } from "./GraficBar2.vue?vue&type=template&id=790c036b&scoped=true"
import script from "./GraficBar2.vue?vue&type=script&lang=js"
export * from "./GraficBar2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "790c036b",
  null
  
)

export default component.exports